import { Box, Paper, Stack, Typography, Button } from "@mui/material";
import moment from "moment";
import { Order } from "./types";

interface Props {
  order: Order;
  onAdvance: (order: Order) => void;
  onCancel: (order: Order) => void;
  actionLoading?: boolean;
  showActions?: boolean;
}

const NEXT_STATUS: Record<Order["status_code"], Order["status_code"] | null> = {
  created: "confirmed",
  confirmed: "in_transit",
  in_transit: "ending",
  ending: "delivered",
  delivered: null,
  cancelled: null,
};

const BORDER_COLORS = {
  normal: "#eee",
  warning: "#f59e0b",
  danger: "#dc2626",
};

export default function OrderCard({
  order,
  onAdvance,
  onCancel,
  actionLoading = false,
  showActions = true,
}: Props) {

  const borderColor =
  BORDER_COLORS[order.priority || "normal"];
  
  const canAdvance =
    NEXT_STATUS[order.status_code] !== null && !actionLoading;

  const badgeText =
    order.daysLeft < 0
      ? `Atrasado ${Math.abs(order.daysLeft)}d`
      : order.daysLeft === 0
      ? "Vence hoy"
      : `${order.daysLeft}d`;

  const BADGE_STYLES = {
      normal: {
        bg: "#f3f4f6",
        color: "#374151",
      },
      warning: {
        bg: "#fef3c7",
        color: "#92400e",
      },
      danger: {
        bg: "#fee2e2",
        color: "#991b1b",
      },
    };

  const badgeStyle =
    BADGE_STYLES[order.priority || "normal"];
      
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        borderRadius: 1.5,
        borderColor,
        bgcolor: "#fff",
      }}
    >
      <Stack spacing={1}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box display="flex" alignItems="center" gap={1}>
            <Typography fontSize={14} fontWeight={600}>
              #{order.tracking_code}
            </Typography>

            <Box
              sx={{
                px: 1,
                py: 0.25,
                borderRadius: 1,
                fontSize: 10,
                fontWeight: 600,
                bgcolor: badgeStyle.bg,
                color: badgeStyle.color,
              }}
            >
              {badgeText}
            </Box>
          </Box>

          <Typography fontSize={11} color="text.primary" sx={{fontWeight: 600}}>
            {order.category}
          </Typography>
        </Box>

        {/* Cliente */}
        <Typography fontSize={13} >
          {order.receiver}
        </Typography>

        <Typography fontSize={13}>
          <Box component="span" sx={{ color: "#6b7280" }}>
            Dirección partida:{" "}
          </Box>
          {order.startAddress}
        </Typography>


        <Typography fontSize={13}>
          <Box component="span" sx={{ color: "#6b7280" }}>
            Dirección llegada:{" "}
          </Box>
          {order.arrivalAddress}
        </Typography>
        
        <Typography fontSize={13}>
          <Box component="span" sx={{ color: "#6b7280" }}>
            Fecha de envío:{" "}
          </Box>
          {order.transferDate}
        </Typography>

        <Typography fontSize={13}>
          <Box component="span" sx={{ color: "#6b7280" }}>
            Fecha estimada llegada:{" "}
          </Box>
          {order.estimatedDeliveryDate}
        </Typography>

        <Typography fontSize={13}>
          <Box component="span" sx={{ color: "#6b7280" }}>
            Conductor:{" "}
          </Box>
          {order.driver} ({order.vehicle})
        </Typography>



        {/* Productos */}
        <Box>
          {/* {order.detail.map((item, idx) => (
            <Typography
              key={idx}
              fontSize={12}
              color="text.secondary"
            >
              {item.quantity}× {item.name}
            </Typography>
          ))} */}
        </Box>

        {/* Nota */}
        {/* {order.notes && (
          <Typography
            fontSize={11}
            color="text.secondary"
            sx={{
              bgcolor: "#f7f7f7",
              p: 0.75,
              borderRadius: 1,
            }}
          >
            {order.notes}
          </Typography>
        )} */}

        {/* Actions */}
        {showActions && (
          <Box display="flex" justifyContent="space-between" mt={0.5}>
            <Button
              size="small"
              onClick={() => onCancel(order)}
              sx={{ fontSize: 11, color: "text.secondary" }}
            >
              Cancelar
            </Button>

            <Button
              size="small"
              disabled={!canAdvance}
              onClick={() => onAdvance(order)}
              sx={{
                fontSize: 11,
                fontWeight: 500,
                bgcolor: "#000",
                color: "#fff",
                "&:hover": { bgcolor: "#111" },
                "&.Mui-disabled": {
                  bgcolor: "#e5e5e5",
                  color: "#999",
                },
              }}
            >
              Avanzar
            </Button>
          </Box>
        )}

      </Stack>
    </Paper>
  );
}
